var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2136 7.57174C17.7521 7.57174 18.9995 6.32446 18.9995 4.78587C18.9995 3.24728 17.7521 2 16.2136 2C14.675 2 13.4277 3.24728 13.4277 4.78587C13.4277 6.32446 14.675 7.57174 16.2136 7.57174Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78587 7.57174C7.32446 7.57174 8.57173 6.32446 8.57173 4.78587C8.57173 3.24728 7.32446 2 5.78587 2C4.24728 2 3 3.24728 3 4.78587C3 6.32446 4.24728 7.57174 5.78587 7.57174Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2136 19.1489C17.7521 19.1489 18.9995 17.9016 18.9995 16.363C18.9995 14.8244 17.7521 13.5771 16.2136 13.5771C14.675 13.5771 13.4277 14.8244 13.4277 16.363C13.4277 17.9016 14.675 19.1489 16.2136 19.1489Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78587 19.1489C7.32446 19.1489 8.57173 17.9016 8.57173 16.363C8.57173 14.8244 7.32446 13.5771 5.78587 13.5771C4.24728 13.5771 3 14.8244 3 16.363C3 17.9016 4.24728 19.1489 5.78587 19.1489Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallJobIcon);
export default __webpack_public_path__ + "static/media/smallJobIcon.e2f6e65910823e7dff25f4c8a7b1312d.svg";
export { ForwardRef as ReactComponent };